export default "__VITE_ASSET__DrrmBZ2w__"